var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      staticClass: "align-btn-center",
      attrs: {
        size: "medium",
        hasCancelBtn: false,
        title: _vm.$t("tenancy.lifecycle.statusTitle"),
      },
    },
    [
      _c("HKLTable", {
        staticClass: "lifecycle non-margin",
        attrs: { columns: _vm.columns, dataSource: _vm.parsedHistories },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }